// Extract the path portion of the URL returned by `CreateInstoreCartUrlDocument` and append
// our additional query params. The mutation returns an absolute URL on a non-consumer host,
// so passing it directly to `router.push` would force a hard navigation off the marketplace
// origin. We push the path only, which Next.js routes client-side within the same app.
export function buildInstoreCartPath(rawUrl: string, extraParams: Record<string, string | undefined>): string {
  const url = new URL(rawUrl);
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value);
    }
  });
  return `${url.pathname}${url.search}${url.hash}`;
}
